/**
 * CuidaDF - Tela de abertura (Splash)
 */

import React from "react";
import "../styles/Splash.css";
import logoInstituto from "../assets/logo-instituto.png";
import InstallButton from "./InstallButton";

function Splash({ onComecar }) {
  return (
    <div className="tela-splash">
      <div className="splash-logo">
        <img src={logoInstituto} alt="Instituto Proteção & Amor" />
      </div>

      <h1 className="splash-titulo">
        Cuida<span>DF</span>
      </h1>
      <p className="splash-subtitulo">Orientação de Saúde</p>

      <p className="splash-tagline">
        Saúde pública mais acessível
        <br />
        para todos os moradores do DF
      </p>

      <div className="splash-patrocinio">
        Serviço gratuito oferecido por
        <strong>Instituto Proteção &amp; Amor</strong>
      </div>

      <button className="btn-splash-iniciar" onClick={onComecar}>
        Começar →
      </button>

      <div style={{ marginTop: "12px", width: "100%" }}>
        <InstallButton />
      </div>
    </div>
  );
}

export default Splash;
